<template>
  <v-app>
    <l-nav-drawer
      :clipped="clipped"
      :items="navDrawerItems"
    >
    </l-nav-drawer>
    <not-auth-toolbar can-go-back show-login>
      <v-toolbar-title slot="title">
        <span>通知中心</span>
      </v-toolbar-title>
    </not-auth-toolbar>
    <v-content>
      <router-view></router-view>
    <!--  <v-container fill-height jusify-center>
        <v-layout class="pt-5 subheading">
          <v-flex class="text-xs-center grey&#45;&#45;text">没有消息通知</v-flex>
        </v-layout>
      </v-container>-->
    </v-content>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
import NotAuthToolbar from '../APP/Toolbar/notAuthToolbar'
import AppFooter from '../APP/Footer/appFooter'
import {navDrawerItems} from '@/router/navDrawerItems'
import LNavDrawer from '../../ladmin/components/LMain/LNavDrawer'
export default {
  name: 'NotificationCenter',
  components: {AppFooter, NotAuthToolbar, LNavDrawer},
  data: () => ({
    navDrawerItems: navDrawerItems,
    clipped: true
  }),
}
</script>

<style scoped>

</style>
